export const KeyUpGlobalConstants = {
  CALENDAR_ORDER_IN_KEY_QUEUE: 100,
};
